{
  "zod": {
    "invalid": "This value will not do",
    "invalidType": "Expected {{expected}}",
    "invalidValue": "Value not allowed",
    "invalidFormat": "Does not match the {{format}} format",
    "tooShort": "Shorter than {{min}} characters",
    "tooLong": "Longer than {{max}} characters",
    "tooSmall": "Less than {{min}}",
    "tooBig": "Greater than {{max}}",
    "tooFew": "At least {{min}} required",
    "tooMany": "At most {{max}} allowed",
    "notMultipleOf": "Must be a multiple of {{step}}",
    "unrecognizedKeys": "Unexpected fields: {{keys}}"
  },
  "address": {
    "ipv4": "An address looks like 192.168.0.10",
    "rangeOrder": "The start of the range must not be greater than its end",
    "rangeTooBig": "A range holds at most {{max}} addresses",
    "tooMany": "A node holds at most {{max}} additional addresses",
    "duplicate": "Address {{address}} is listed twice",
    "sameAsNode": "{{address}} is the primary address of the node"
  },
  "name": {
    "required": "A name is required"
  },
  "secret": {
    "required": "A secret is required",
    "tooLong": "The secret is longer than {{max}} characters"
  },
  "password": {
    "tooShort": "The password is shorter than {{min}} characters",
    "tooLong": "The password is longer than {{max}} characters"
  },
  "email": {
    "invalid": "This is not a valid email address"
  },
  "user": {
    "roleRequired": "At least one role is required"
  },
  "organization": {
    "slug": "Lowercase Latin letters, digits, and hyphens between them"
  },
  "credential": {
    "sshUserRequired": "SSH needs a username",
    "passphraseOnlyForKey": "Only a private key can have a passphrase"
  },
  "agent": {
    "platform": "The platform is written as linux/amd64",
    "version": "The version is written as 1.2.0",
    "fileName": "File name: Latin letters, digits, dot, hyphen, and underscore",
    "checksum": "The checksum is 64 hexadecimal characters"
  },
  "archive": {
    "speed": "Playback speed: {{speeds}}",
    "rangeTooWide": "An interval wider than {{days}} days is not served in one request"
  },
  "range": {
    "startBeforeEnd": "The start of the interval must come before its end"
  },
  "camera": {
    "streamPathRequired": "A stream path is required",
    "streamPathSlash": "The stream path starts with a slash",
    "streamPathChars": "The stream path cannot contain spaces, backslashes, or a hash sign"
  },
  "recorder": {
    "templateRequired": "A path template is required for a recorder without an API",
    "templateSlash": "The path template starts with a slash",
    "templateChars": "The path template cannot contain spaces, backslashes, or a hash sign",
    "templateChannel": "The template needs a place for the channel number: {channel}"
  },
  "discovery": {
    "cidrFormat": "The subnet is written as 192.168.10.0/24",
    "cidrTooWide": "The subnet must be no larger than /{{prefix}} — otherwise the scan stretches into hours"
  },
  "file": {
    "pathTooLong": "The path is longer than {{max}} characters",
    "pathInvalid": "Invalid path: the separator is “/”, the “..” and “.” segments are not allowed, and neither are the characters \\ < > \" | ? * or control characters",
    "pathRequired": "No path given",
    "newPathRequired": "No new path given",
    "transferId": "Malformed transfer id"
  },
  "layout": {
    "nameRequired": "A layout name is required",
    "duplicateCell": "Two cameras in one cell",
    "cellOutOfGrid": "The cell is outside the chosen grid"
  },
  "monitor": {
    "oid": "An OID is written as digits separated by dots",
    "timeoutOverInterval": "The timeout must not exceed the check interval"
  },
  "node": {
    "color": "A color like #rgb or #rrggbb is expected",
    "selfLink": "A link from a node to itself means nothing"
  },
  "notifications": {
    "emailInvalid": "A valid address is required",
    "recipientRequired": "Give at least one recipient",
    "chatIdRequired": "Give the chat id",
    "urlInvalid": "A full address is required, including http:// or https://",
    "urlScheme": "Only http and https are supported",
    "headerName": "Header name: visible ASCII characters without spaces",
    "headerValue": "Header value: visible ASCII characters only"
  },
  "common": {
    "badId": "Malformed identifier"
  },
  "cameras": {
    "ticketRequired": "A ticket is required"
  }
}
